import axios from 'axios'
import u from '@/utils'

const state = {
  executionCount: []
}

const mutations = {
  setExecutionCount(state, executionCount) {
    state.executionCount = executionCount
  }
}

const actions = {
  async fetchExecutionCount({ commit }) {
    let response = await axios.get(`/api/v1/executions/count`)
    if (
      response.data._embedded &&
      response.data._embedded.decimalMeasureByDateModels
    ) {
      let requestCount = [...response.data._embedded.decimalMeasureByDateModels]
      requestCount = requestCount.map(step => u.processResp(step))
      commit('setExecutionCount', requestCount)
      return requestCount
    }
  }
}

export default {
  state,
  mutations,
  actions
}
